import type { FilterBillingCycleLabels, FilterStateLabels, FilterTypeLabels } from './types'

export const FILTER_BILLING_CYCLE_LABELS: FilterBillingCycleLabels = {
  Month: 'Monthly',
  Year: 'Annual',
}

export const FILTER_STATE_LABELS: Omit<FilterStateLabels, 'None'> = {
  Active: 'Active',
  Expiring: 'Expiring',
  Former: 'Former',
  PastDue: 'Past due',
  FreeTrial: 'Free trial',
}

export const FILTER_TYPE_LABELS: FilterTypeLabels = {
  member: 'Member',
  free: 'Free account',
}
